'use strict';

require('react-html5video/dist/ReactHtml5Video.css');

import React from 'react';
import Button from 'components/clarity-ui/inputs/button';
import Modal from 'components/clarity-ui/components/modal/modal';
import ModalContent from 'components/clarity-ui/components/modal/modalContent';
import ModalButtons from 'components/clarity-ui/components/modal/modalButtons';
import Video from 'react-html5video';

class VideoModal extends React.Component {

  getVideoStyles () {
    return {width: 330+'px', height: 184+'px'};
  }

  getVideoSource (videoId) {
    return `https://affine.s3.amazonaws.com/video/${videoId}`;
  }

  getVideoPoster (videoId, posterFrame) {
    return `https://pilbox.set.tv?url=/thumbnail/${videoId}/${posterFrame}&w=259&h=138&mode=scale&frame=${posterFrame}`;
  }

  renderVideoSource (videoId, videoType) {
    return (
      <source src={this.getVideoSource(videoId)} type={videoType} />
    );
  }

  renderVideoLayer (videoId, posterFrame) {
    return (
      <div>
        <Video
          controls
          style={this.getVideoStyles()}
          src={this.getVideoSource(videoId)}
          poster={this.getVideoPoster(videoId, posterFrame)}
        >
          { this.renderVideoSource(videoId, 'video/mp4') }
          { this.renderVideoSource(videoId, 'video/ogg') }
          { this.renderVideoSource(videoId, 'video/webm') }
        </Video>
        <div>
          Video ID: { videoId }
        </div>
      </div>
    );
  }

  getWebPageImagePoster (webPageId) {
    return `https://pilbox.set.tv?url=/screenshot/${webPageId}&amp;w=330&amp;h=186&amp;mode=scale`;
  }

  renderPageLinkLayer (webPageLink, webPageId, webPageDomain) {
    return (
      <div>
        <a href={webPageLink} target="_blank">
            <img src={this.getWebPageImagePoster(webPageId)} />
        </a>
        <div>
          <div>Page ID: {webPageId}</div>
          <div title={webPageDomain}>Domain: {webPageDomain}</div>
        </div>
      </div>
    );
  }

  render () {
    const { video, isActive, handleCloseOnClick } = this.props,
          { videoId, page, defaultFrame, frames } = video,
          videoFrame = frames[defaultFrame].frame;
    return (
      <Modal isActive={isActive} height={6} width={6} title={page.title} handleCloseOnClick={handleCloseOnClick}>
        <ModalContent>
          <div className="Grid">
            <div className="Grid-cell--1of2">
              { this.renderVideoLayer(videoId, videoFrame) }
            </div>
            <div className="Grid-cell--1of2">
              { this.renderPageLinkLayer(page.remoteId, page.id, page.domain) }
            </div>
          </div>
        </ModalContent>
        <ModalButtons>
          <Button elementType="button" onClick={handleCloseOnClick}>Close</Button>
        </ModalButtons>
      </Modal>
    );
  }
}

export default VideoModal;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/targetResults/videoResults/videoModal.component.jsx